import React from "react";
import { ChevronRightIcon } from "../Auth/onboarding/icons";
import { suggestedPrompts } from "./botReplies";

export default function SuggestedPromptsCard({ onSelect }) {
  return (
    <section className="dash-card">
      <div className="dash-card-header">
        <h2 className="cz-card-title">Try asking</h2>
      </div>

      <ul className="dash-quick-actions">
        {suggestedPrompts.map((prompt) => (
          <li key={prompt}>
            <button type="button" className="dash-quick-action asst-prompt-btn" onClick={() => onSelect(prompt)}>
              <span className="asst-prompt-text">{prompt}</span>
              <ChevronRightIcon />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
